import { Auth } from "shared/@auth/Auth";
import { useQuery } from "react-query";

export const useActiveTickets = (filters) => {
  const { makeAuthedRequest } = Auth.useContainer();

  return useQuery(
    ["activeTickets", filters],
    () => {
      const encodedOwners = filters.owners.map(encodeURIComponent).join(";");
      return makeAuthedRequest(
        `v1/reporting/active-tickets/type/${filters.type}/owner/${
          encodedOwners || null
        }/year/${filters.year}`,
        { method: "GET" }
      ).then((res) => res.json());
    },
    {
      enabled: !!filters,
      staleTime: 0,
      refetchOnWindowFocus: false,
    }
  );
};
